import { render, staticRenderFns } from "./Notas.vue?vue&type=template&id=529186ce&scoped=true"
import script from "./Notas.vue?vue&type=script&lang=js"
export * from "./Notas.vue?vue&type=script&lang=js"
import style0 from "./Notas.vue?vue&type=style&index=0&id=529186ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529186ce",
  null
  
)

export default component.exports